import { render, staticRenderFns } from "./Geschaeftspartner.vue?vue&type=template&id=a7c1b0d8"
import script from "./Geschaeftspartner.vue?vue&type=script&lang=js"
export * from "./Geschaeftspartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports